import {TimeUtils} from '@vdw/angular-component-library';
import {DateTime} from 'luxon';
import {PatternShift} from '../pattern/pattern-shift';

export class SchedulePreview {
  private _date: DateTime;
  private _isHoliday: boolean;
  private _isWorkingDay: boolean;
  private _shifts: PatternShift[];

  public constructor(date: DateTime, isHoliday: boolean, isWorkingDay: boolean, shifts: PatternShift[]) {
    this._date = date;
    this._isHoliday = isHoliday;
    this._isWorkingDay = isWorkingDay;
    this._shifts = shifts;
  }

  public get date(): DateTime {
    return this._date;
  }

  public get isHoliday(): boolean {
    return this._isHoliday;
  }

  public get isWorkingDay(): boolean {
    return this._isWorkingDay;
  }

  public get shifts(): PatternShift[] {
    return this._shifts;
  }

  public static fromJSON(schedulePreviewJSON: any): SchedulePreview {
    const date = DateTime.fromISO(schedulePreviewJSON.date);
    return new SchedulePreview(
      TimeUtils.convertToLocalDateTime(date),
      schedulePreviewJSON.isHoliday,
      schedulePreviewJSON.isWorkingDay,
      schedulePreviewJSON.shifts
        .map((shiftJSON: any) => PatternShift.fromPreviewJSON(shiftJSON, date))
        .sort((shiftA: PatternShift, shiftB: PatternShift) => shiftA.startTime.toMillis() - shiftB.startTime.toMillis())
    );
  }
}
